import TimeTrackComponent from '../TimeTrack.vue'

export default [
    {
        path: '/timetrack',
        name: 'TimeTrack',
        meta: { layout: 'default' },
        component: TimeTrackComponent,
    },
]